import React from "react"
import { Flex, Image } from "@chakra-ui/react"
import poweredBy from "assets/images/powered-by-diobox.png"

type Props = {
  whiteLabel: boolean
}

const PoweredByDiobox = ({ whiteLabel }: Props) => (
  <Flex justify="center" py={8} borderBottomRadius="lg">
    <Image src={poweredBy} maxW="110px" opacity={whiteLabel ? 0.4 : 1} />
  </Flex>
)

export default PoweredByDiobox
